<nav class="tig-flt-r navbar navbar-top">
	<div class="navbar-right">
		<ng-container *ngIf="OBJ_router.url=='/client-selection'">
			<!-- back -->
			<button class="btn btn-default btn-circle" (click)="goBack()" title="{{'back'|translate}}">
				<i class="fa fa-reply"></i>
			</button>
			<!-- logout -->
			<button class="btn btn-default btn-circle" [routerLink]="['/login']" title="{{'oMisc.sLogout'|translate}}">
				<i class="fa fa-sign-out"></i>
			</button>
		</ng-container>
		<!-- languages -->
		<div dropdown>
			<button class="btn btn-default btn-circle active" dropdownToggle title="{{'languages'|translate}}">{{OBJ_translate_service.currentLang.toUpperCase()}}</button>
			<div class="animated fadeInDown dropdown-menu" *dropdownMenu>
				<ng-container *ngFor="let STR_lang of OBJ_translate_service.getLangs()">
					<button type="button" *ngIf="STR_lang !== OBJ_translate_service.currentLang" class="btn btn-default btn-circle" (click)="OBJ_translate_service.use(STR_lang)">
						{{STR_lang.toUpperCase()}}
					</button>
				</ng-container>
			</div>
		</div>
	</div>
</nav>
<!-- View/routes wrapper-->
<router-outlet></router-outlet>
<!-- up -->
<button class="btn btn-warning btn-circle btn-top" (click)="goTop()">
	<i class="fa fa-arrow-up"></i>
</button>
